import TimingType from '../store/schema/TimeSuggestionsTimingTypes';
import { CalendarComponent } from 'owa-calendar-usage-instrumentation';

export function createDefaultTimeSuggestionsStore() {
    return {
        timeSuggestions: null,
        previousStart: null,
        previousMeetingDurationInMinutes: 0,
        timeSuggestionsRequestState: null,
        lastFindMeetingTimesRequestId: null,
        lastFindMeetingTimesRequestDate: null,
        showSearchCriteriaDialog: false,
        durationSearchCriteria: 0,
        timingSearchCriteria: TimingType.NextAvailable,
        shouldAdjustStartTimeEndTime: false,
        calendarComponent: CalendarComponent.Unknown,
        ariaRequestCompletionResourceId: '',
    };
}
